export default __webpack_public_path__ + "static/media/animated-infra.d57ac878.png";